<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :dataForm="dataForm"
            :extra="extra"
            @viewActionPlan="viewActionPlan"
        ></base-crud>
        <router-link :to="'/worker'" class="btn btn-normal float-right">Voltar</router-link>
    </div>
</template>

<script>
import BaseCrud from "../../Base/BaseCrud";
export default {
    data() {
        return {
            crudName: "Planos de Ação",
            newText: "",
            table: "workerActionPlansTable",
            columns: [
                "id",
                "research_id",
                "name",
                "priority_id",
                "answer",
                "actions"
            ],
            tableData: ["id", "research_id", "name", "priority_id", "answer"],
            options: {
                filterByColumn: true,
                debounce: 1000,
                sortable: [
                    "id",
                    "research_id",
                    "name",
                    "priority_id",
                    "answer"
                ],
                filterable: [
                    "id",
                    "research_id",
                    "name",
                    "priority_id",
                    "answer"
                ],
                pagination: { chunk: 10, dropdown: false, nav: "scroll" },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "#",
                    research_id: "Pesquisa",
                    name: "Nome",
                    priority_id: "Prioridade",
                    answer: "Respondido",
                    actions: "Ações"
                },
                templates: {
                    research_id(h, row) {
                        return row.research.name;
                    },
                    priority_id(h, row) {
                        return row.priority.name;
                    },
                    answer(h, row) {
                        return row.answer ? (
                            <i class="fas fa-check green"></i>
                        ) : (
                            <i class="fas fa-times red"></i>
                        );
                    }
                },
                requestFunction: function(data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [
                        "priority",
                        "research",
                        "answer"
                    ];

                    return this.$http
                        .get(this.url + "?" + query, requestData)
                        .catch(
                            function(e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                }
            },
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud extra-one",
                    title: "Visualizar",
                    name: "viewActionPlan",
                    icon: "fas fa-eye"
                }
            ],
            endPoint: "actionplans/",
            dataForm: {}
        };
    },
    methods: {
        viewActionPlan(props, row, index) {
            this.$router.push({
                path: "/worker/actionPlan/" + props.props.row.id
            });
        },
        query: function(query) {
            let columns = {
                id: "id",
                research_id: "research[name]",
                name: "name",
                priority_id: "priority[name]"
            };
            let filters = "";
            $.each(query, function(index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        }
    },
    mounted() {},
    components: {
        BaseCrud
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Worker/ActionPlan/List.vue